import React from 'react'
import Slider from 'react-slick';
import { ReactComponent as PercentIcon } from '../../../assets/icons/booking_percent.svg';
import { ReactComponent as OfferRupeeIcon } from '../../../assets/plus_icon/offer_rupee.svg';
import { ReactComponent as LeftSlideIcon } from '../../../assets/icons/left.svg';
import { ReactComponent as RightSlideIcon } from '../../../assets/icons/righticon.svg'

function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
        <div
            className={className}
            onClick={onClick}
        >
            <div className='w-6 h-6 hover:!bg-grey-light inline-flex items-center justify-center bg-white rounded !border !border-grayLight'><RightSlideIcon /></div>

        </div >
    );
}

function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
        <div
            className={className}
            onClick={onClick}
        >
            <div className='w-6 h-6 hover:!bg-grey-light inline-flex items-center justify-center bg-white rounded !border !border-grayLight'> <LeftSlideIcon /></div>


        </div>
    );
}

const settings = {
    dots: false,
    infinite: false,
    arrows: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    // centerPadding: '60px',
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />
};

const Offers = ({ offers, setShowSitevisitModal, setSelectedProject, project }) => {
    return (
        <Slider {...settings}>
            {
                offers.map((offer, index) => (
                    <div key={offer.uuid}>
                        {/* <div className='!border rounded-xl border-grayLight px-3 py-2 text-xs !w-[200px] h-[92px] offer-card relative !mr-3 overflow-hidden'> */}
                        <div className='rounded-xl !w-[200px] h-[92px] !mr-3 overflow-hidden cursor-pointer' onClick={(e) => {
                            e.stopPropagation()
                            setShowSitevisitModal(true);
                            setSelectedProject(project.uuid)
                        }}>
                            <img src={offer.image_url} alt="" />
                            {/* {offer.offer_type !== 'Site visit' && <div className='!mb-2'><PercentIcon /></div>}
                            <div>
                                <span className='text-base block'>
                                    <span className='text-[#684EFB] !text-base font-bold !mr-1'><span className='text-[#344054] text-base font-bold'>₹ {offer.amount}</span></span> <span className='text-[10px] text-[#667085]'>for</span></span>
                                {offer.offer_type === 'Site visit' && <span className='text-xs text-[#667085] !mt-1.5 font-medium leading-3 py-1'>Site Visit Completion</span>}
                                {offer.offer_type !== 'Site visit' && <span className='bg-clip-text text-transparent bg-gradient-to-r from-[#684EFB] to-[#2064FA] text-xs !mt-1.5 font-medium'> Spot booking</span>}
                            </div>
                            {offer.offer_type === 'Site visit' &&
                                <button className='bg-gradient-to-r from-[#684EFB] to-[#2064FA] text-[10px] font-bold text-white uppercase !px-2 !py-1 rounded-lg !mt-2' onClick={(e) => {
                                    e.stopPropagation()
                                    setShowSitevisitModal(true);
                                    setSelectedProject(project.uuid)
                                }}>
                                    Schedule SV Now
                                </button>}
                            <div className='absolute right-0 bottom-0'>                               
                                <OfferRupeeIcon />
                            </div> */}
                        </div>
                    </div>
                ))
            }
        </Slider>
    )
}

export default Offers